import { Heading, RadioCircle } from '@expressable/syntax-ds';
import classNames from 'classnames';
import React from 'react';
import { twMerge } from 'tailwind-merge';

interface ChoiceCardProps {
  title: string;
  children?: React.ReactNode;

  checked?: boolean;

  onClick: () => void;
  className?: string;
}

export const ChoiceCard: React.FC<ChoiceCardProps> = ({ title, children, checked, onClick, className }) => {
  return (
    <button
      className={twMerge(
        classNames(
          'flex flex-col items-stretch divide-y border-warm-gray-700 border divide-warm-gray-700 ',
          'desktop:hover:bg-orchid-100',
          'rounded-xl',
          'text-left',
          {
            'bg-orchid-50': checked === true,
            'bg-white': !checked,
          },
          className,
        ),
      )}
      onClick={onClick}
    >
      <div className="p-e32 flex items-center justify-between">
        <Heading level="h3" noDefaultMargins className="whitespace-break-spaces">
          {title}
        </Heading>{' '}
        <RadioCircle checked={checked} />
      </div>

      <div className="p-e32">{children}</div>
    </button>
  );
};
